import { ACTION_SET_STRING } from "../actions/strings";

const DEFAULT_STATE = {
    prompt: '',
    emptyPrompt: '',
    filteredObjectsName: '',
    previewLinkText: '',
};

export default function stringsReducer(state, action) {
    if (!state) {
        state = {...DEFAULT_STATE};
    }

    switch (action.type) {
        case ACTION_SET_STRING:
            state = {
                ...state,
                [action.key]: action.string
            }
            break
    }

    return state;
}
